<template>
  <div class="mit-network-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Network</v-card-title>
            <v-card-subtitle class="caption">CSAIL Network Information</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="pt-5">
                <a href="https://tig.csail.mit.edu/network-wireless/" target="_blank">Documenation</a>
              </h3>
              <p>CSAIL network information</p>

              <h3 class="pt-5">
                <a href="https://webdns.csail.mit.edu/ " target="_blank">Static IP Allocation and DNS</a>
              </h3>
              <p>Static IP adddress allocation and DNS Name management</p>

              <h3 class="pt-5">
                <a  href="https://dhreg.csail.mit.edu/" target="_blank">Register hosts for automatic IP configuration</a>
              </h3>
              <p>Register hosts for automatic IP configuration (and optionally network install)</p>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitNetworkPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
